/* eslint-disable react/destructuring-assignment */
import React, { FC, useContext } from 'react'

import { Link } from '@Components/Link'
import { ProductContext } from '@Components/Product/Context'
import { SliderContext } from '@Components/Product/Slider/Context/SliderContext'
import { AddToWishList } from '@Components/WishList/addToWishList'
import SliderControls from '@Domains/Product/Features/Display/SliderControls/SliderControls'
import SliderProgress from '@Domains/Product/Features/Display/SliderProgress/SliderProgress'

import styles from './SliderOverlay.module.scss'

const SliderOverlay: FC = () => {
  const product = useContext(ProductContext)
  const {
    activeSlide,
    setActiveSlide,
    slides,
  } = useContext(SliderContext)

  if (!product) {
    return null
  }

  const videoKey = slides.findIndex(slide => slide.tags?.includes('video'))

  return (
    <>
      <div className={`${styles.actions} ${activeSlide.key === videoKey ? styles.hidden : ''}`}>

        <div className={styles.action}>
          <AddToWishList className={styles.wishlistButton} id={product.id} />
        </div>

        {videoKey !== -1 && (
          <button
            aria-label="Play"
            className={`${styles.action} ${styles.play}`}
            onClick={() => setActiveSlide({
              key: videoKey,
              recalculate: true,
            })}
            type="button"
          >
            <svg version="1.1" viewBox="0 0 13 14.2" xmlns="http://www.w3.org/2000/svg">
              <path d="M0,14.2V0l13,7.1L0,14.2ZM1,1.7v10.9l9.9-5.4L1,1.7Z" />
            </svg>
          </button>
        )}
      </div>

      {product.brand && (
        <Link className={styles.brand} href={product.brand.url?.toString()}>
          <img
            alt={product.brand.id || ''}
            src={product.brand.logo || ''}
            title={product.brand.title || ''}
          />
        </Link>
      )}

      <SliderControls />
      <SliderProgress />
    </>
  )
}

export default SliderOverlay
